/**
 * Kali Shoes — Size Required Helper (v10 minimal disable)
 * 12/05/2026
 *
 * STRATEGIA MINIMAL:
 * - Bottone ATC disabled visivamente (grigio) finché user non sceglie taglia
 * - NO cambio testo (resta "Aggiungi al carrello") → no shift layout = no flicker
 * - NO scroll pin (causava sfarfallio)
 * - Hidden input id svuotato all'init, popolato al click radio
 * - Monkey-patch fetch /cart/add come safety net
 * - Force show all gallery images al click variant
 */
(function() {
  'use strict';

  var SIZE_OPTION_NAMES = ['Taglia', 'taglia', 'Size', 'size', 'Numero', 'numero', 'Misura', 'misura'];

  function isSizeFromName(name) {
    if (!name) return false;
    return SIZE_OPTION_NAMES.indexOf(name) !== -1;
  }

  function findSizeRadios(form) {
    var formId = form.getAttribute('id');
    var out = [];
    if (formId) {
      document.querySelectorAll('input[type="radio"][form="' + formId + '"]').forEach(function(r) {
        if (isSizeFromName(r.getAttribute('name'))) out.push(r);
      });
    }
    if (out.length === 0) {
      form.querySelectorAll('input[type="radio"]').forEach(function(r) {
        if (isSizeFromName(r.getAttribute('name'))) out.push(r);
      });
    }
    if (out.length === 0) {
      var section = form.closest('section, .product, [data-section-id]');
      if (section) {
        section.querySelectorAll('input[type="radio"]').forEach(function(r) {
          if (isSizeFromName(r.getAttribute('name'))) out.push(r);
        });
      }
    }
    return out;
  }

  function getVariantsJson(form) {
    var section = form.closest('section, .product, [data-section-id]');
    var search = section || document;
    var script = search.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function findVariantBySize(variants, size) {
    if (!variants) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 === size || v.title === size) return v;
    }
    return null;
  }

  function deselectAllRadios(radios) {
    radios.forEach(function(r) {
      r.checked = false;
      r.removeAttribute('checked');
      r.defaultChecked = false;
    });
  }

  function disableBtn(btn) {
    btn.disabled = true;
    btn.classList.add('kk-btn-disabled');
    btn.setAttribute('aria-disabled', 'true');
  }

  function enableBtn(btn) {
    btn.disabled = false;
    btn.classList.remove('kk-btn-disabled');
    btn.removeAttribute('aria-disabled');
  }

  function forceShowAllGalleryImages() {
    var selectors = [
      '.product__media-list li',
      '.product__media-item',
      '[data-media-id]',
      '.product__media-wrapper',
      '.product-single__media',
      'media-gallery li',
      'product-media-gallery li',
      '.slider__slide'
    ];
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.style.display = '';
        el.style.visibility = '';
        el.removeAttribute('hidden');
        el.classList.remove('hidden', 'is-hidden', 'media--hidden');
      });
    });
  }

  function setupForm(form) {
    if (form.dataset.kkSizeSetup === '1') return;
    var radios = findSizeRadios(form);
    if (radios.length === 0) return;
    form.dataset.kkSizeSetup = '1';
    form.dataset.kkUserChose = '0';

    deselectAllRadios(radios);

    var hidden = form.querySelector('input[type="hidden"][name="id"]');
    if (hidden) {
      hidden.dataset.kkOriginalId = hidden.value;
      hidden.value = '';
    }

    var btn = form.querySelector('button[name="add"], .product-form__submit');
    if (btn) disableBtn(btn);

    // MutationObserver: combatti il ri-check di variant-radios
    var fightChecker = function() {
      if (form.dataset.kkUserChose === '1') return;
      deselectAllRadios(radios);
    };
    radios.forEach(function(r) {
      var mo = new MutationObserver(fightChecker);
      mo.observe(r, { attributes: true, attributeFilter: ['checked'] });
    });
    setTimeout(fightChecker, 100);
    setTimeout(fightChecker, 500);
    setTimeout(fightChecker, 1500);

    function onUserChose(r) {
      form.dataset.kkUserChose = '1';
      var size = r.value;
      var variants = getVariantsJson(form);
      var variant = findVariantBySize(variants, size);
      if (variant && variant.id && hidden) {
        hidden.value = variant.id;
      }
      if (btn) enableBtn(btn);
      r.checked = true;
      // Force gallery to show all images (combatti filter Kalles)
      forceShowAllGalleryImages();
      setTimeout(forceShowAllGalleryImages, 100);
      setTimeout(forceShowAllGalleryImages, 500);
    }
    radios.forEach(function(r) {
      var lbl = document.querySelector('label[for="' + r.id + '"]');
      // ANTI-SCROLL: salva e ripristina scroll Y immediatamente prima/dopo focus
      function preventFocusScroll(e) {
        var savedY = window.scrollY;
        // Re-pin scroll immediatamente dopo che il browser tenta scroll-into-view
        requestAnimationFrame(function() {
          if (Math.abs(window.scrollY - savedY) > 1) window.scroll(0, savedY);
        });
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            if (Math.abs(window.scrollY - savedY) > 1) window.scroll(0, savedY);
          });
        });
      }
      r.addEventListener('focus', preventFocusScroll, true);
      r.addEventListener('click', function() { preventFocusScroll(); onUserChose(r); });
      r.addEventListener('change', function() { onUserChose(r); });
      if (lbl) {
        lbl.addEventListener('mousedown', preventFocusScroll, true);
        lbl.addEventListener('touchstart', preventFocusScroll, {capture: true, passive: true});
        lbl.addEventListener('click', function() {
          setTimeout(function() { onUserChose(r); }, 10);
        });
      }
    });
  }

  // CSS bottone disabilitato + anti-scroll-on-focus radio taglia
  var style = document.createElement('style');
  style.textContent = [
    '.kk-btn-disabled, button.product-form__submit.kk-btn-disabled {',
    '  background-color: #888 !important;',
    '  color: #fff !important;',
    '  cursor: not-allowed !important;',
    '  opacity: 0.85 !important;',
    '  pointer-events: auto !important;',
    '}',
    '.kk-btn-disabled:hover {',
    '  background-color: #888 !important;',
    '}',
    /* FIX scroll mobile: dice al browser di NON scrollare per portare i radio Taglia in viewport */
    'input[type="radio"][name="Taglia"],',
    'input[type="radio"][name="taglia"],',
    'input[type="radio"][name="Size"],',
    'input[type="radio"][name="Numero"],',
    'input[type="radio"][name="Misura"] {',
    '  scroll-margin-top: 9999px !important;',
    '  scroll-margin-bottom: 9999px !important;',
    '}',
    /* Anche per i label associati */
    '.product-form__input label, fieldset.product-form__input {',
    '  scroll-margin-top: 9999px !important;',
    '  scroll-margin-bottom: 9999px !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  // Monkey-patch fetch /cart/add safety net
  if (window.fetch && !window._kkFetchPatched) {
    var originalFetch = window.fetch;
    window.fetch = function(input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (url && url.indexOf('/cart/add') > -1 && init && init.body) {
          var body = init.body;
          var idStr = '';
          if (body instanceof FormData) {
            idStr = body.get('id') || '';
          } else if (typeof body === 'string') {
            try {
              var parsed = JSON.parse(body);
              idStr = parsed.id || (parsed.items && parsed.items[0] && parsed.items[0].id) || '';
            } catch (e) {
              var m = body.match(/[?&]?id=([^&]+)/);
              idStr = m ? m[1] : '';
            }
          }
          if (!idStr || idStr === '' || idStr === 'null') {
            console.warn('[kk-size] Blocco /cart/add: variant id mancante');
            return Promise.reject(new Error('kk-size: select size first'));
          }
        }
      } catch (err) {}
      return originalFetch.apply(this, arguments);
    };
    window._kkFetchPatched = true;
  }

  function init() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(setupForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function(muts) {
    muts.forEach(function(m) {
      m.addedNodes && m.addedNodes.forEach(function(n) {
        if (n.nodeType === 1) {
          if (n.matches && n.matches('form[action*="/cart/add"]')) setupForm(n);
          if (n.querySelectorAll) n.querySelectorAll('form[action*="/cart/add"]').forEach(setupForm);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
